<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="qwoach-form my-5 error-no-expand">
		<el-form :model="form" :rules="rules" ref="mainForm" @submit.native.prevent="submitForm()">

			<FormTextRow
				prop="title"
				v-model="form.title"
				placeholder="What is the name of this coaching program?">
			</FormTextRow>

			<div>
				<small class="text-muted">Note: the name of the coaching program will be visible to your clients once you invite them to join the program.</small>
			</div>



		</el-form>
	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import CoachingProgram, {ProgramCategoryEnum, ProgramTypeEnum} from "@shared/Program/CoachingProgram";
import {plainToClass} from "class-transformer";

export default {
	name: "SetupNameStep",
	components: {FormTextRow},
	extends: BaseWizardStep,

	data() {
		return {
			form: {
				title: '',
				isGroup:false,
			},
			rules: {
				title: [
					{
						required: true,
						whitespace: false,
						message: 'Please specify a name for this coaching program',
						trigger: 'validate'
					},
				],
			},

			programItem: null
		}
	},

	methods:{
		// async validateForm(){
		// 	return true
		// }

		stepId(){
			return "create_program_step"
		},

		isStepRequired(){
			return true
		},


		async restoreState(savedState){
			this.programItem = plainToClass(CoachingProgram, savedState[this.stepId()])

			if(this.programItem){
				this.form.title = this.programItem.name
			}
		},


		async onNextClicked(){
			if(!this.programItem){
				this.programItem = await this.createProgramItem()
			} else {
				this.programItem = await this.updateProgramItem()
			}

			return this.programItem
		},

		async updateProgramItem(){
			if(this.programItem.name !== this.form.title){
				this.programItem.name = this.form.title;
				return await this.$dataManager.updateProgram(this.programItem)
			}
			return this.programItem
		},

		async createProgramItem(){
			this.programItem = CoachingProgram.createStubCoachingProgram(this.ownerProfile.id)
			this.programItem.name = this.form.title;
			this.programItem.programType = this.form.isGroup ? ProgramTypeEnum.GROUP : ProgramTypeEnum.ONE_ON_ONE;
			this.programItem.coachId = this.currentUser.uid
			let heading = this.form.isGroup ? "0 participants" : "(invite a client)";
			this.programItem.headingTitle = heading;
			this.programItem.addOwner(this.userProfile.id)
			this.programItem.expandFirstStepsFor(this.userProfile.id, 3)

			this.programItem.programCategory = ProgramCategoryEnum.TEMPLATE
			this.programItem.coachName = this.userProfile.name

			this.programItem = await this.$dataManager.createProgram(this.programItem)
			return this.programItem
		},

		stepDescription(){
			return this.form.title
		},


		getProgressText(){
			return "Saving..."
		},

		getTitle(){
			return "Coaching program name"
		}


	},

}
</script>

<style lang="scss">

</style>
